import _ from 'underscore';

export const getUpdatedAssets = ({
  assets,
  updates = {},
}) => {
  const {
    imageCroppingTasks,
    videoUpdated,
  } = updates || {};

  if (assets &&
    (!_.isEmpty(imageCroppingTasks) || !_.isEmpty(videoUpdated))
  ) {
    let updatedAssets = assets;

    if (!_.isEmpty(imageCroppingTasks)) {
      updatedAssets = updatedAssets.map((asset) => {
        const taskStatus = imageCroppingTasks[asset.id];
        if (taskStatus) {
          return {
            ...asset,
            updating: !taskStatus.isFinished,
          };
        }

        return asset;
      });
    }

    if (!_.isEmpty(videoUpdated)) {
      updatedAssets = updatedAssets.map((asset) => {
        const newUpdates = videoUpdated[asset.id];
        if (newUpdates && newUpdates.status !== asset.status) {
          return {
            ...asset,
            ...newUpdates,
          };
        }

        return asset;
      });
    }

    return updatedAssets;
  }

  return assets;
};
